<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp42',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-42">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-42-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 2)"
        :key="`modules-id-42-item-${i}`"
        class="item"
        :class="{'item-reverse': i === 1}"
        @click="onModuleItem(v)"
      >
        <div class="img-box">
          <el-image class="item-img" :src="v.photo | imgPath" alt="img" fit="cover" />
        </div>
        <p class="item-memo h-line-2">{{ v.memo ? filtersRichtext(v.memo) : '' }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-42-content {
  display: flex;
  column-gap: 75px;
  .item {
    width: 280px;
    height: 334px;
    border-radius: 5px;
    // border: 1px solid #000;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 30px;
  }
  .item-reverse {
    display: flex;
    flex-direction: column-reverse;
  }
  .img-box {
    width: 308px;
    height: 203px;
    position: relative;
    display: grid;
    place-items: center;
    .item-img {
      width: 160px;
      height: 100px;
      margin-top: 3px;
    }
    &::after {
      content: '';
      width: 308px;
      height: 203px;
      background: url('~imgs/modules/comp43t2-bg.png') no-repeat center;
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
  }
  .item-memo {
    width: 257px;
    font-size: 13px;
    color: #268877;
    font-family: siyuansong;
    line-height: 19px;
    letter-spacing: 4px;
    text-indent: 2em;
  }
}
</style>
